import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import colors from '../../configuration/colors'
import { hideModal } from '../../actions/modal'
import Modal from '../mini/Modal'
import Button from '../mini/Buttons/Button'
import styled from 'styled-components'
import Deleted from '../../static/images/icon_delete_redhover.svg'

const ModalContainer = styled.div`
  width: 519px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.15);
  background: ${colors.white};
  margin: 180px auto;
  padding-top: 40px;
`

const Header = styled.div`
  padding: 0 23px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  margin-bottom: 13px;
`

const DeleteIcon = styled.div`
  background: url(${Deleted}) no-repeat;
  background-size: 100%;
  height: 35px;
  width: 29px;
`

const MainContainer = styled.div`
  padding-bottom: 43px;
  border-bottom: 1px solid ${colors.ash};
  background-color: ${colors.white};
  border: none;
  margin: 0 auto;
  text-align: center;
`

const DescriptionText = styled.h3`
  width: 419px;
  color: ${colors.black};
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  padding-bottom: 12px;
`

const ButtonBlock = styled.div`
  border-top: 1px solid ${colors.rock};
`

const DeleteResourceModal = ({handleDeleteResource}) => {
  const dispatch = useDispatch()

  const handleDelete = () => {
    handleDeleteResource()

    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  const closeTheModal = () => {
    setTimeout(() => {
      dispatch(hideModal())
    }, 300)
  }

  return (
    <Modal
      width={1400}
      percentHeight={100}
      background={'rgba(36,54,70,0.48)'}
      lockBodyScroll={false}
      opacity={'.9'}
      allowCloseOnExternalClick={false}
    >
      <ModalContainer closeCallback={closeTheModal}>
        <Header>
          <DeleteIcon/>
        </Header>
        <MainContainer>
          <DescriptionText>
            Are you sure you want to delete this resource?
          </DescriptionText>
          <p className='p2' style={{marginBottom: '0'}}>Once deleted, this cannot be undone.</p>
        </MainContainer>
        <ButtonBlock>
          <div style={{marginLeft: '46%', padding: '23px 23px 30px 0', display: 'flex'}}>
            <span style={{marginRight: '20px'}}>
              <Button
                buttonColor={colors.white}
                width='104px'
                borderColor={colors.white}
                title='Cancel'
                handleClick={closeTheModal}
                hoverBackground={colors.charcoal4}
                hoverColor={colors.white}
              />
            </span>
            <Button
              buttonColor={colors.white}
              width='129px'
              borderColor='#D23A3D'
              title='Delete'
              handleClick={handleDelete}
              hoverBackground='#D23A3D'
              hoverColor={colors.white}
            />
          </div>
        </ButtonBlock>
      </ModalContainer>
    </Modal>
  )
}

DeleteResourceModal.propTypes = {
  handleDeleteResource: PropTypes.func.isRequired
}

export default DeleteResourceModal



// WEBPACK FOOTER //
// ./src/components/modal/DeleteResourceModal.js